import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import {
  PROFILE_TYPE_TRANSLATOR,
  PROFILE_TYPE_VOICEACTOR,
  PROFILE_TYPE_SINGER,
  PROFILE_TYPE_ADAPTOR,
  PROFILE_TYPE_LYRICIST,
  PROFILE_TYPE_EDITOR,
  PROFILE_TYPE_SOUNDENGINEER,
  PROFILE_TYPE_BOOKER
} from '../../../../constants'
import WithAjax from '../../../common/helpers/WithAjax'
import WithNotify from '../../../common/helpers/WithNotify'
import {clearSkillVendorCurrentProfile} from '../../../../actions/pages/skillvendor-page'

class RequestTestsOrSamplesPopup extends Component {
  constructor() {
    super()

    this.requestFor = this.requestFor.bind(this)
  }

  requestFor(urlPart) {
    let url = 'skillVendors/' + this.props.skillVendorId + '/profiles/' + this.props.profileType + '/' + urlPart;
    this.props.ajax.put(url, null, null, () => {
      this.props.clearSkillVendorCurrentProfile();

      let message = this.props.profileType === 'VoiceActor'
        ? 'The request for samples was sent.'
        : 'The request for tests was sent.';
      this.props.notify(message);
    })
  }

  isSamplesRequired(){
    return this.props.profileType === PROFILE_TYPE_SINGER
      || this.props.profileType === PROFILE_TYPE_VOICEACTOR
  }

  render() {
    return (
      <div style={{display: 'inline-block'}}>
      {this.props.isQualificationTestAvailable &&
        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={() => { if (window.confirm('Are you sure?')) this.requestFor('requesttests'); }}>
          Ask for tests
        </button>
      }
      {this.isSamplesRequired() &&
        <button
          className="btn btn-primary btn-rounded mx-2"
          type="button"
          onClick={() => { if (window.confirm('Are you sure?')) this.requestFor('requestsamples'); }}>
          Ask for samples
        </button>
      }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  skillVendorId: state.skillVendorPage.overview.Id,
  profileType: state.skillVendorPage.currentProfile.ProfileType,
  isQualificationTestAvailable: state.skillVendorPage.currentProfile.IsQualificationTestAvailable
})
const mapDispatchToProps = dispatch => ({
  clearSkillVendorCurrentProfile() { dispatch(clearSkillVendorCurrentProfile()) }
})
export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  WithNotify,
  WithAjax)(RequestTestsOrSamplesPopup)
